
























import { Component, Vue } from 'vue-property-decorator';
import PageHeaderError from '@/components/PageHeaderError.vue';
import SvgErrorIcon from '@/components/SvgErrorIcon.vue';
import ColorButton from '@/components/ColorButton.vue';
import Qrcode from '@/components/Qrcode.vue';

@Component({
  components: {
    PageHeaderError,
    SvgErrorIcon,
    ColorButton,
    Qrcode
  }
})
export default class Page extends Vue {
  private get url(): string {
    return this.$store.getters['auth/requestURL'];
  }
}
